import { resourcesService } from "app/services";
import { useQuery } from "@tanstack/react-query";

export function useDepartamentos() {
  const departamentosDeHonduras = useQuery({
    queryKey: ["departamentos-de-honduras"],
    queryFn: resourcesService.getDepartamentosDeHonduras,
  });

  return departamentosDeHonduras;
}
